import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "339",
  "slug": "daily-geography-habit-5-minutes",
  "title": "A Five-Minute Geography Routine",
  "excerpt": "A short session built around one question and a second look at a mistake.",
  "date": "2026-06-03",
  "category": "Education",
  "image": "https://images.unsplash.com/photo-1670915891542-63251e9ea5d9?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxnbG9iZSUyMGRlc2t8ZW58MXwwfHx8MTc4MDQ3NzM2M3ww&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Choose a small question before opening a game or atlas: which countries border Peru, where does the Rhine reach the sea, or how does a delta look from above? Five minutes is enough to attempt one question and check your answer. It is a convenient time limit, not a scientifically established dose."
    },
    {
      "type": "heading",
      "text": "A session you can repeat"
    },
    {
      "type": "list",
      "items": [
        "Spend the first minute answering without looking it up. Sketch a border, name the neighbours, or mark a location.",
        "Use the next two minutes to check a map or reliable reference. Find the particular feature you missed.",
        "Use the last two minutes to explain the correction in a sentence and choose one question to revisit."
      ]
    },
    {
      "type": "paragraph",
      "text": "For example, if you put Uruguay on the Pacific coast, locate it beside the Río de la Plata and identify its neighbours. Checking that relationship is more useful than simply recording a wrong answer."
    },
    {
      "type": "heading",
      "text": "Keep a small record"
    },
    {
      "type": "paragraph",
      "text": "Use two columns: the question and the correction. On another day, cover the corrections and try again. Retest with a different map or image when possible, so that you are not just remembering where an answer sat on one screen."
    },
    {
      "type": "paragraph",
      "text": "A regular time may make the routine easier to remember. If you miss it, resume when you can. A streak records attendance; it does not measure what you know."
    },
    {
      "type": "heading",
      "text": "Change the task when it stops helping"
    },
    {
      "type": "paragraph",
      "text": "Repeatedly naming countries you already recognise adds little. Move to their neighbours, rivers, regions, or unfamiliar views. Equally, if every answer is a guess, narrow the region or use a labelled map first."
    },
    {
      "type": "paragraph",
      "text": "After a few sessions, retry an earlier question without your notes. Use that result to choose the next task. There is no need to promise yourself a sharper memory or a complete world map in a month."
    }
  ],
  "relatedSlugs": [
    "30-days-playing-earthguessr-experiment",
    "memorize-all-195-countries-in-a-month"
  ]
};
